<template>
  <div
    type="button"
    :class="[classes, pointClass]"
    class="select-rewrite"
    @click="passMethod('click')"
  >
    <select
      class="ocean-ui-form-select"
      :class="selectClass"
      style="float:left;width:100%;height:100%;color:inherit;outline:inherit;font-size:inherit;position:relative;z-index:1;}"
      v-model="selectVal"
      ref="selectEle"
      @change="onSelect($event.target.value)"
    >
      <slot></slot>
    </select>
    <Icon
      :type="icon"
      class="ocean-ui-list-item-after-icon ocean-ui-select-after-icon icon"
      v-if="iconTypeAssigned && !isIE"
      :active="active"
      :style="afterIconStyles"
    ></Icon>
  </div>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
import iconSetting from '../../mixins/iconSetting';
import { isIE } from '../../device';
export default {
  mixins: [themeMixins, iconSetting],
  props: ['value', 'icon', 'active', 'rightSpan', 'selectClass'],
  data() {
    return {
      selectVal: this.value,
      isIE: isIE()
    };
  },
  computed: {
    showIcon() {
      return undefined != this.iconTheme && this.iconTheme;
    },
    showDefault() {
      return undefined != this.iconTheme && this.iconTheme == 'default';
    },
    iconTypeAssigned() {
      let assigned = this.icon !== undefined;
      return assigned;
    }
  },
  watch: {
    value(newVal) {
      this.selectVal = newVal;
    }
  },
  methods: {
    onSelect(value) {
      this.$emit('input', value);
      this.$emit('change', value);
      const selectEle = this.$refs.selectEle;
      selectEle && typeof selectEle.blur === 'function' && selectEle.blur();
    }
  },
  mounted() {
    let _self = this;
    // 这里和上面的blur，主要是为了避免在选中select的时候切换屏幕再回来时会自动触发聚焦上报。
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState == 'hidden') {
        try {
          const selectElem = _self.$refs.selectEle;
          selectElem &&
            typeof selectElem.blur === 'function' &&
            selectElem.blur();
        } catch (error) {}
      }
    });
  }
};
</script>

<style scoped lang="scss">
.selectIcon {
  position: absolute;
  width: 20.5px;
  display: block;
  &.selectIcon-defalt {
    color: inherit;
    right: 24px;
    top: 50%;
    transform: translateY(-50%) rotate(90deg);
  }
}
.select-rewrite {
  padding: 0 !important;
  .ocean-ui-form-select {
    padding: 0 2vh;
  }
}
.ocean-ui-form-select {
  border: 0;
  -webkit-appearance: none;
  background: transparent;
}

.ocean-ui-list-item-after-icon {
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>
